import styled from 'styled-components';
import { device } from '@/styles/helpers';

interface IScLobbyGamesSlideProps {
  rows: number;
  cols: number;
}

export const ScLobbyGamesSlide = styled.div<IScLobbyGamesSlideProps>`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  grid-template-rows: ${({ rows }) => `repeat(${rows}, 1fr)`};
  gap: 16px;
  padding: 4px;

  @media (${device.tablet}) {
    gap: 16px 8px;
  }
`;
